export type BenefitFeedbackKind = "used" | "rule_wrong";

export type BenefitFeedback = {
  benefitId: string;
  kind: BenefitFeedbackKind;
  note: string;
  reportedAt: string;
};

const STORAGE_KEY = "mofaxiaoka.mvp.benefitFeedback.v1";

export function loadFeedback(): Record<string, BenefitFeedback> {
  if (typeof localStorage === "undefined") return {};
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return {};
    return parsed as Record<string, BenefitFeedback>;
  } catch {
    return {};
  }
}

export function saveFeedback(map: Record<string, BenefitFeedback>): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function recordFeedback(
  benefitId: string,
  kind: BenefitFeedbackKind,
  note = ""
): Record<string, BenefitFeedback> {
  const map = loadFeedback();
  const existing = map[benefitId];
  if (existing && existing.kind === kind) {
    delete map[benefitId];
  } else {
    map[benefitId] = {
      benefitId,
      kind,
      note,
      reportedAt: new Date().toISOString()
    };
  }
  saveFeedback(map);
  return map;
}

export function feedbackOf(map: Record<string, BenefitFeedback>, benefitId: string): BenefitFeedback | undefined {
  return map[benefitId];
}
